import React, { useState, useRef, useEffect, useContext } from "react";
import { Store } from "react-notifications-component";
import { AwesomeButton } from "react-awesome-button";
import { Row, Col, Form, Card, Button, Image } from "react-bootstrap";
import classes from "./SupplyIn.module.css";
import axios from "axios";
import ImageResizer from "react-image-file-resizer";
import ModalOkay from "./Modals/ModalOkay";
import { AutoComplete, Divider } from "rsuite";
import "rsuite/dist/rsuite.css";
import InputText from "../Elements/InputText.jsx";
import InputSelect from "../Elements/InputSelect.jsx";
import PermissionContext from "../../Store/permission-context";
const ChangePrice = () => {
  const PCtx = useContext(PermissionContext);
  const [Itemname, setItemname] = useState("");
  const [SoldIn, setSoldIn] = useState("");
  const [QBulk, setQBulk] = useState("");
  const [QUnit, setQUnit] = useState("");
  const [CostPrice, setCostPrice] = useState("");
  const [Newname, setNewname] = useState("");
  const [Converter, setConverter] = useState("");
  const [ItemID, setItemID] = useState("");
  const [SP1, setSP1] = useState("");
  const [SP2, setSP2] = useState("");
  const [SP3, setSP3] = useState("");
  const [UP1, setUP1] = useState("");
  const [UP2, setUP2] = useState("");
  const [UP3, setUP3] = useState("");
  const [ISP1, setISP1] = useState("");
  const [ISP2, setISP2] = useState("");
  const [ISP3, setISP3] = useState("");
  const [IUP1, setIUP1] = useState("");
  const [IUP2, setIUP2] = useState("");
  const [IUP3, setIUP3] = useState("");
  const [IQBulk, setIQBulk] = useState("");
  const [IQUnit, setIQUnit] = useState("");
  const [IConverter, setIConverter] = useState("");
  const [AxiosError, setAxiosError] = useState("");
  const [bulkvalue, setbulkvalue] = useState("Carton");
  const [checkup, setcheckup] = useState(true);
  const [checksp, setchecksp] = useState(true);
  const [ErrorSP1, setErrorSP1] = useState(false);
  const [ErrorSP2, setErrorSP2] = useState(false);
  const [ErrorSP3, setErrorSP3] = useState(false);
  const [ErrorUP1, setErrorUP1] = useState(false);
  const [ErrorUP2, setErrorUP2] = useState(false);
  const [ErrorUP3, setErrorUP3] = useState(false);
  const [ItHasBulk, setItHasBulk] = useState(true);
  const [convreadonly, setconvreadonly] = useState(false);
  const [readonly, setreadonly] = useState(true);
  const [ThereIsPicture, setThereIsPicture] = useState(false);
  const [ItemHasChanged, setItemHasChanged] = useState(false);
  const [AllGoodNames, setAllGoodNames] = useState([]);
  const [AllGoodIds, setAllGoodIds] = useState([]);
  const [Itemdetails, setItemdetails] = useState([]);
  const [ShowOkAlert, setShowOkAlert] = useState(false);
  const [Okmessage, setOkmessage] = useState("");
  const [Oktitle, setOktitle] = useState("");
  const SoldInRef = useRef(null);
  const ConverterRef = useRef(null);
  const SP1Ref = useRef(null);
  const SP2Ref = useRef(null);
  const SP3Ref = useRef(null);
  const UP1Ref = useRef(null);
  const UP2Ref = useRef(null);
  const UP3Ref = useRef(null);
  const [pictureSelected, setpictureSelected] = useState(null);
  const [PictureDirectory, setPictureDirectory] = useState("");
  // const { addToast } = useToasts();

  const checkboxHandler = (e) => {
    if (e.target.checked) {
      setreadonly(false);
    } else {
      setreadonly(true);
      setNewname("");
    }
  };

  const compressImage = (file, targetSizeInKb) => {
    return new Promise((resolve, reject) => {
      ImageResizer.imageFileResizer(
        file,
        500, // Set the maximum width to 600 pixels
        500, // Set the maximum height to 600 pixels
        "JPEG", // Set the output format to JPEG
        targetSizeInKb, // Set the target file size in kilobytes
        0, // Set the quality level to 0 (the library will adjust the quality to achieve the target size)
        (uri) => {
          resolve(uri);
        },
        "base64"
      );
    });
  };

  const base64ToBlob = (base64) => {
    const parts = base64.split(";base64,");
    const contentType = parts[0].split(":")[1];
    const byteCharacters = atob(parts[1]);
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays.push(byteCharacters.charCodeAt(i));
    }

    const blob = new Blob([new Uint8Array(byteArrays)], { type: contentType });
    return blob;
  };

  const changePicture = async (event) => {
    setThereIsPicture(false);
    let namP = event.target.name;
    let valP = event.target.files[0];
    var FileSize = valP.size / 1024;
    // console.log(FileSize);
    //   var FileSize = valP.size / 1048576; // in MBin MB
    //   var FileSize = valP.size / 1073741824; // in KBin KB
    // if (FileSize > 1000) {
    //   valP = null;
    //   // alert("Picture size exceeds 200kb");
    //   PCtx.displayAlert("Error", "Picture size exceeds 400KB", "danger");
    // } else {
    let str = event.target.value;

    // if (
    //   str.endsWith("jpg") ||
    //   str.endsWith("JPG") ||
    //   str.endsWith("jpeg") ||
    //   str.endsWith("JPEG")
    // ) {
    valP = await compressImage(valP, 50);
    setPictureDirectory(URL.createObjectURL(base64ToBlob(valP)));
    setpictureSelected(base64ToBlob(valP));
    setThereIsPicture(true);
    // } else {
    //   PCtx.displayAlert(
    //     "Error",
    //     "Only picture in jpg or jpeg format is accepted",
    //     "danger"
    //   );
    //   // console.log("Only picture in jpg or jpeg format is accepted");
    // }
  };

  const SoldInChange = (iv) => {
    setSoldIn(iv);
    setbulkvalue(iv);
    if (iv === "Unit" || iv === "Pieces") {
      setConverter("1");
      setconvreadonly(true);
      setItHasBulk(false);
      setQBulk("");
    } else {
      setConverter("");
      setconvreadonly(false);
      setItHasBulk(true);
    }
  };

  const CheckUnitPrice = () => {
    setcheckup(!checkup);
  };

  const CheckBulkPrice = () => {
    setchecksp(!checksp);
  };

  // To load stored items from the database
  useEffect(() => {
    let Allnames = [];
    let AllIDs = [];
    const getData = async () => {
      let AllGoods = await PCtx.connectAxios("getallgoods.php", "");

      for (var y = 0; y < AllGoods.length; y++) {
        AllIDs[y] = AllGoods[y][0];
        Allnames[y] = AllGoods[y][1];
      }
    };
    getData();
    setAllGoodNames(Allnames);
    setAllGoodIds(AllIDs);
  }, []);

  useEffect(() => {
    let up = parseFloat(CostPrice) / parseFloat(Converter);
    if (parseFloat(UP1Ref.current.value) >= 0 && UP1Ref.current.value < up) {
      PCtx.displayAlert(
        "Selling Price Error",
        "The Unit Selling Price 1 should not be less than Unit Cost Price. Check the value(s) highlighted in Red",
        "danger"
      );

      setErrorUP1(true);
    } else {
      setErrorUP1(false);
    }
    if (parseFloat(UP2Ref.current.value) >= 0 && UP2Ref.current.value < up) {
      PCtx.displayAlert(
        "Selling Price Error",
        "The Unit Selling Price 2 should not be less than Unit Cost Price. Check the value(s) highlighted in Red",
        "danger"
      );
      setErrorUP2(true);
    } else {
      setErrorUP2(false);
    }
    if (parseFloat(UP3Ref.current.value) >= 0 && UP3Ref.current.value < up) {
      PCtx.displayAlert(
        "Selling Price Error",
        "The Unit Selling Price 3 should not be less than Unit Cost Price. Check the value(s) highlighted in Red",
        "danger"
      );
      setErrorUP3(true);
    } else {
      setErrorUP3(false);
    }
  }, [checkup]);

  //This runs whenever the Selling Price is changed to ensure that the carton selling price than carton cost price
  useEffect(() => {
    let cp = parseFloat(CostPrice);
    if (parseFloat(SP1Ref.current.value) >= 0 && SP1Ref.current.value < cp) {
      setErrorSP1(true);
      PCtx.displayAlert(
        "Selling Price Error",
        "The " +
          bulkvalue +
          " Selling Price 1 should not be less than " +
          bulkvalue +
          "  Cost Price. Check the value(s) highlighted in Red",
        "danger"
      );
    } else {
      setErrorSP1(false);
    }

    if (parseFloat(SP2Ref.current.value) >= 0 && SP2Ref.current.value < cp) {
      setErrorSP2(true);
      PCtx.displayAlert(
        "Selling Price Error",
        "The " +
          bulkvalue +
          " Selling Price 2 should not be less than " +
          bulkvalue +
          "  Cost Price. Check the value(s) highlighted in Red",
        "danger"
      );
    } else {
      setErrorSP2(false);
    }
    if (parseFloat(SP3Ref.current.value) >= 0 && SP3Ref.current.value < cp) {
      setErrorSP3(true);
      PCtx.displayAlert(
        "Selling Price Error",
        "The " +
          bulkvalue +
          " Selling Price 3 should not be less than " +
          bulkvalue +
          "  Cost Price. Check the value(s) highlighted in Red",
        "danger"
      );
    } else {
      setErrorSP3(false);
    }
  }, [checksp]);

  useEffect(() => {
    let itdetails = [
      {
        title: "Item Name",
        value: Itemname === "" ? "No item selected" : Itemname,
      },
      {
        title: "Quantity left (" + SoldIn + ")",
        value: IQBulk === "" ? 0 : IQBulk,
      },
      {
        title: "Quantity left (Unit)",
        value: IQUnit === "" ? 0 : IQUnit,
      },
      {
        title: SoldIn + " Selling Price 1",
        value: ISP1 === "" ? "₦0" : "₦" + ISP1,
      },
      {
        title: SoldIn + " Selling Price 2",
        value: ISP2 === "" ? "₦0" : "₦" + ISP2,
      },
      {
        title: SoldIn + " Selling Price 3",
        value: ISP3 === "" ? "₦0" : "₦" + ISP3,
      },
      {
        title: " Unit Selling Price 1",
        value: IUP1 === "" ? "₦0" : "₦" + IUP1,
      },
      {
        title: " Unit Selling Price 1",
        value: IUP2 === "" ? "₦0" : "₦" + IUP2,
      },
      {
        title: " Unit Selling Price 1",
        value: IUP3 === "" ? "₦0" : "₦" + IUP3,
      },
    ];

    setItemdetails(itdetails);
  }, [ItemHasChanged]);

  //To get the item picked
  const getItemnameSelection = async (it) => {
    let goodproperties = await PCtx.connectAxios("getitemdetails.php", it);
    setItemID(goodproperties.GoodID);
    setSoldIn(goodproperties.Soldin);
    setCostPrice(goodproperties.CostPrice);
    setConverter(goodproperties.Converter);
    setIConverter(goodproperties.Converter);
    setSP1(goodproperties.SP1);
    setSP2(goodproperties.SP2);
    setSP3(goodproperties.SP3);
    setUP1(goodproperties.UP1);
    setUP2(goodproperties.UP2);
    setUP3(goodproperties.UP3);
    setISP1(goodproperties.SP1);
    setISP2(goodproperties.SP2);
    setISP3(goodproperties.SP3);
    setIUP1(goodproperties.UP1);
    setIUP2(goodproperties.UP2);
    setIUP3(goodproperties.UP3);
    setIQBulk(goodproperties.QBulk);
    setIQUnit(goodproperties.QUnit);
    setPictureDirectory(`/applauseinfotech/phpfiles/${goodproperties.PUrl}`);
    setItemHasChanged(!ItemHasChanged);
  };

  const getTypedText = () => {
    let ITN = Itemname.charAt(0).toUpperCase() + Itemname.slice(1);
    if (AllGoodNames.includes(ITN)) {
      getItemnameSelection(ITN);
    } else {
      setSoldIn("");
      setCostPrice("");
      setNewname("");
      setQBulk("");
      setQUnit("");
      setConverter("");
      setSP1("");
      setSP2("");
      setSP3("");
      setUP1("");
      setUP2("");
      setUP3("");
    }
  };

  const nextOKEvent = () => {
    setShowOkAlert(false);
    window.location.reload();
  };
  //Submitting the supply form
  const submitItemForm = async (e) => {
    e.preventDefault();
    if (ErrorSP1 || ErrorSP2 || ErrorSP3 || ErrorUP1 || ErrorUP2 || ErrorUP3) {
      PCtx.displayAlert(
        "ERROR IN SAVING",
        Itemname +
          " cannot be saved. Please check the value(s) highlighted in Red.",
        "danger"
      );
    } else {
      let rep = "";
      let IsNewItem = true;
      if (AllGoodNames.includes(Newname)) {
        PCtx.displayAlert(
          "ERROR IN SAVING",
          Newname + " is already existing. Please pick another name",
          "danger"
        );
      } else {
        IsNewItem = false;
        let sp1 = SP1 === "" ? 0 : SP1;
        let sp2 = SP2 === "" ? 0 : SP2;
        let sp3 = SP3 === "" ? 0 : SP3;
        let up1 = UP1 === "" ? 0 : UP1;
        let up2 = UP2 === "" ? 0 : UP2;
        let up3 = UP3 === "" ? 0 : UP3;
        let isp1 = ISP1 === "" ? 0 : ISP1;
        let isp2 = ISP2 === "" ? 0 : ISP2;
        let isp3 = ISP3 === "" ? 0 : ISP3;
        let iup1 = IUP1 === "" ? 0 : IUP1;
        let iup2 = IUP2 === "" ? 0 : IUP2;
        let iup3 = IUP3 === "" ? 0 : IUP3;

        if (parseFloat(sp1) !== parseFloat(isp1)) {
          rep +=
            PCtx.Username +
            " Changed the " +
            SoldIn +
            " price 1 of " +
            Itemname +
            " from " +
            isp1 +
            " to " +
            sp1;
        }
        if (parseFloat(sp2) !== parseFloat(isp2)) {
          rep +=
            PCtx.Username +
            " Changed the " +
            SoldIn +
            " price 2 of " +
            Itemname +
            " from " +
            isp2 +
            " to " +
            sp2;
        }
        if (parseFloat(sp3) !== parseFloat(isp3)) {
          rep +=
            PCtx.Username +
            " Changed the " +
            SoldIn +
            " price 3 of " +
            Itemname +
            " from " +
            isp3 +
            " to " +
            sp3;
        }

        if (parseFloat(up1) !== parseFloat(iup1)) {
          rep +=
            PCtx.Username +
            " Changed the Unit price 1 of " +
            Itemname +
            " from " +
            iup1 +
            " to " +
            up1;
        }
        if (parseFloat(up2) !== parseFloat(iup2)) {
          rep +=
            PCtx.Username +
            " Changed the Unit price 2 of " +
            Itemname +
            " from " +
            iup2 +
            " to " +
            up2;
        }
        if (parseFloat(up3) !== parseFloat(iup3)) {
          rep +=
            PCtx.Username +
            "Changed the Unit price 3 of " +
            Itemname +
            " from " +
            iup3 +
            " to " +
            up3;
        }
        if (parseFloat(Converter) !== parseFloat(IConverter)) {
          rep +=
            PCtx.Username +
            "Changed the quantity in one " +
            SoldIn +
            " of " +
            Itemname +
            " from " +
            IConverter +
            " to " +
            Converter;
        }

        if (Newname !== Itemname && !readonly && Newname != "") {
          rep +=
            PCtx.Username +
            " Changed the name of " +
            Itemname +
            " to " +
            Newname;
        }

        const supplyproperties = {
          myItemname: Itemname,
          myNewname: Newname,
          mySoldIn: SoldIn,
          myCostPrice: CostPrice,
          myConverter: Converter,
          mySP1: ItHasBulk ? SP1 : "",
          mySP2: ItHasBulk ? SP2 : "",
          mySP3: ItHasBulk ? SP3 : "",
          myUP1: UP1,
          myUP2: UP2,
          myUP3: UP3,
          logreport: rep,
          isNew: IsNewItem,
          staff: PCtx.Username,
        };

        let resp = await PCtx.connectAxios(
          "updateproperties.php",
          supplyproperties
        );

        if (resp.includes("Error")) {
          PCtx.displayAlert(
            "ERROR IN SAVING ITEM",
            "There was an error in saving " +
              Itemname +
              ". Please check all the values you supplied again",
            "danger"
          );
        } else {
          if (ThereIsPicture) {
            let fmdata = new FormData();
            fmdata.append("ItemID", ItemID);
            pictureSelected != null &&
              fmdata.append("pictureSelected", pictureSelected, Itemname);
            await axios({
              method: "post",
              url: "/applauseinfotech/phpfiles/savenewimage.php",
              headers: {
                // "Content-type": "multipart/form-data",
                "Content-type": "multipart/form-data",
              },
              data: fmdata,
            }).then((result) => {
              var dat = result.data;
              console.log(dat);
              if (dat.includes("Success")) {
                setPictureDirectory(null);
              }
            });
          }

          setOkmessage("All Changes saved successfully.");
          setOktitle("SUCCESS!");
          setShowOkAlert(true);
        }
      }
    }
  };
  return (
    <div>
      <Row>
        <Col>
          <Card>
            <Card.Body>
              <Divider>
                <h3
                  className="text-center"
                  style={{ color: "brown", fontFamily: "Times New Roman" }}
                >
                  PRICE/IMAGE MODIFICATION
                </h3>
              </Divider>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="justify-content-around">
        <Col md={12} sm={12} xs={12} className="mx-0 px-0">
          <Row className="justify-content-around px-5">
            <Col md={12} lg={12} sm={8} xs={12} className="mx-0 px-0">
              <Card>
                <Card.Header
                  className="text-center text-bg"
                  style={{ color: "brown", fontFamily: "Times New Roman" }}
                >
                  ITEM MODIFICATION FORM
                </Card.Header>
                <Card.Body>
                  <Form onSubmit={submitItemForm}>
                    <Row className="justify-content-around px-5">
                      <Col md={8} sm={8} xs={12} className="mx-0 px-0">
                        <Row className="justify-content-around">
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label style={{ color: "brown" }}>
                                Item Name
                              </Form.Label>
                              <AutoComplete
                                data={AllGoodNames}
                                value={Itemname}
                                onChange={setItemname}
                                onSelect={getItemnameSelection}
                                onBlur={getTypedText}
                                style={{ border: "1px solid brown" }}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <hr />
                        <Row>
                          <Col md={4}>
                            <Row>
                              <Col md={1} xs={1} sm={1}>
                                <input
                                  type="checkbox"
                                  onChange={checkboxHandler}
                                />
                              </Col>
                              <Col md={11} xs={11} sm={11}>
                                <InputText
                                  label="Change Item name"
                                  labelcolor="brown"
                                  myVal={Newname}
                                  myName="Converter"
                                  myOnChange={setNewname}
                                  placeholder="Enter new name here"
                                  required={true}
                                  readonly={readonly}
                                />
                              </Col>
                            </Row>
                            <hr style={{ padding: "0px", margin: "0px" }} />
                          </Col>
                          <Col md={4}>
                            <InputSelect
                              label="Bulk is sold in"
                              labelcolor="brown"
                              myRef={SoldInRef}
                              myVal={SoldIn}
                              myOptions={[
                                "Select",
                                "Carton",
                                "Bag",
                                "Sachet",
                                "Dozen",
                                "Rolls",
                                "Pack",
                                "Unit",
                                "Piece",
                              ]}
                              myName="SoldIn"
                              myOnChange={SoldInChange}
                              inputType="number"
                              required={true}
                            />
                            <hr />
                          </Col>

                          <Col md={4}>
                            <InputText
                              label={"One " + bulkvalue + " contains ?"}
                              labelcolor="brown"
                              myVal={Converter}
                              myRef={ConverterRef}
                              myName="Converter"
                              myOnChange={setConverter}
                              inputType="number"
                              placeholder="How many units/pieces?"
                              required={true}
                              readonly={
                                convreadonly || Itemname === "" || SoldIn === ""
                                  ? true
                                  : false
                              }
                            />
                            <hr />
                          </Col>
                        </Row>
                        {ItHasBulk && (
                          <Row>
                            <Col md={4}>
                              <InputText
                                label={"One " + bulkvalue + " Selling Price 1"}
                                labelcolor="brown"
                                myVal={SP1}
                                myRef={SP1Ref}
                                myName="SP1"
                                myOnChange={setSP1}
                                inputType="number"
                                getAction={CheckBulkPrice}
                                error={ErrorSP1}
                                readonly={
                                  Itemname === "" || SoldIn === ""
                                    ? true
                                    : false
                                }
                              />
                              <hr />
                            </Col>
                            <Col md={4}>
                              <InputText
                                label={"One " + bulkvalue + " Selling Price 2"}
                                labelcolor="brown"
                                myVal={SP2}
                                myRef={SP2Ref}
                                myName="SP2"
                                myOnChange={setSP2}
                                inputType="number"
                                placeholder="Optional"
                                getAction={CheckBulkPrice}
                                error={ErrorSP2}
                                readonly={
                                  Itemname === "" || SoldIn === ""
                                    ? true
                                    : false
                                }
                              />
                              <hr />
                            </Col>
                            <Col md={4}>
                              <InputText
                                label={"One " + bulkvalue + " Selling Price 3"}
                                labelcolor="brown"
                                myVal={SP3}
                                myRef={SP3Ref}
                                myName="SP3"
                                myOnChange={setSP3}
                                inputType="number"
                                getAction={CheckBulkPrice}
                                placeholder="Optional"
                                error={ErrorSP3}
                                readonly={
                                  Itemname === "" || SoldIn === ""
                                    ? true
                                    : false
                                }
                              />
                              <hr />
                            </Col>
                          </Row>
                        )}
                        <Row>
                          <Col md={4}>
                            <InputText
                              label="One Unit/Pieces Selling Price 1"
                              labelcolor="brown"
                              myVal={UP1}
                              myRef={UP1Ref}
                              myName="UP1"
                              myOnChange={setUP1}
                              inputType="number"
                              getAction={CheckUnitPrice}
                              error={ErrorUP1}
                              readonly={
                                Itemname === "" || SoldIn === "" ? true : false
                              }
                            />
                            <hr />
                          </Col>
                          <Col md={4}>
                            <InputText
                              label="One Unit/Pieces Selling Price 2"
                              labelcolor="brown"
                              myVal={UP2}
                              myRef={UP2Ref}
                              myName="UP2"
                              myOnChange={setUP2}
                              inputType="number"
                              getAction={CheckUnitPrice}
                              error={ErrorUP2}
                              placeholder="Optional"
                              readonly={
                                Itemname === "" || SoldIn === "" ? true : false
                              }
                            />
                            <hr />
                          </Col>
                          <Col md={4}>
                            <InputText
                              label="One Unit/Pieces Selling Price 3"
                              labelcolor="brown"
                              myVal={UP3}
                              myRef={UP3Ref}
                              myName="UP3"
                              myOnChange={setUP3}
                              inputType="number"
                              getAction={CheckUnitPrice}
                              error={ErrorUP3}
                              readonly={
                                Itemname === "" || SoldIn === "" ? true : false
                              }
                              placeholder="Optional"
                            />
                            <hr />
                          </Col>
                        </Row>
                      </Col>
                      <Col md={4} sm={4} xs={12} className="mx-0 px-0">
                        <Row className="justify-content-around">
                          <Col md={12} lg={12} sm={12} xs={12}>
                            <Row className="justify-content-around">
                              <Col
                                md={8}
                                lg={8}
                                sm={12}
                                xs={12}
                                className="d-flex justify-content-center"
                              >
                                <Image
                                  thumbnail
                                  src={PictureDirectory}
                                  alt="Item Image"
                                  style={{ width: "400px", height: "300px" }}
                                />
                              </Col>
                              <Col
                                md={8}
                                lg={8}
                                sm={12}
                                xs={12}
                                className="d-flex justify-content-center"
                              >
                                <Form.Group
                                  controlId="formfile"
                                  className="mb-3"
                                >
                                  <Form.Label
                                    style={{
                                      color: "brown",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Select Picture
                                  </Form.Label>
                                  <Form.Control
                                    type="file"
                                    name="Pix4"
                                    value={null}
                                    onChange={changePicture}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12} md={12} sm={12} className="">
                        <Button type="submit" style={{ width: "100%" }}>
                          Save Data
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>

        <ModalOkay
          message={Okmessage}
          okshow={ShowOkAlert}
          title={Oktitle}
          nextEvent={nextOKEvent}
        />
      </Row>
    </div>
  );
};

export default ChangePrice;
